import 'twin.macro';
import 'styled-components/macro';
import { Item, ItemIndicator, ItemText, SelectItemProps } from '@radix-ui/react-select';
import { forwardRef } from 'react';

import { SelectIndicator } from './SelectIndicator';

export const SelectItem = forwardRef<HTMLDivElement, SelectItemProps>(({ children, ...props }, forwardedRef) => (
  <Item
    tw="
      flex
      items-center
      gap-1
      all-child:first:grow

      px-2
      py-1

      text-sm/snug
      text-primary-medium

      select-none
      cursor-pointer

      // Borders are used instead of margins to increase the click area as
      // much as possible
      bg-clip-padding
      border-b-[4px]
      border-t-[4px]
      border-transparent

      data-[disabled]:(text-gray-50 pointer-events-none)
      data-[highlighted]:(bg-gray-5 outline-none text-primary)
    "
    {...props}
    ref={forwardedRef}
  >
    <ItemText>{children}</ItemText>

    <ItemIndicator>
      <SelectIndicator />
    </ItemIndicator>
  </Item>
));
